<template>
  <div>
    <el-row :gutter="0" style="padding:20px">
      <el-form ref="form" :model="form" :rules="rules" size="medium" label-width="78px" label-position="left">
        <el-col :span="14">
          <el-form-item label="生产日期" prop="productionDate">
            <el-input v-model="form.productionDate" placeholder="请输入生产日期" clearable :style="{width: '100%'}">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="保质期" prop="shelfLife">
            <el-input v-model="form.shelfLife" placeholder="请输入保质期" clearable :style="{width: '100%'}">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="存储条件" prop="storageConditions">
            <el-input v-model="form.storageConditions" placeholder="请输入存储条件" clearable
                      :style="{width: '100%'}">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item size="large">
            <el-button type="primary" @click="submitForm" v-loading.fullscreen.lock="fullscreenLoading">提交</el-button>
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="$router.back()">返回</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      fullscreenLoading: false,
      form: {
        productionDate: '',
        shelfLife: '',
        storageConditions: '',
      },
      rules: {
        productionDate: [{
          required: true,
          message: '请输入生产日期',
          trigger: 'change'
        }],
        shelfLife: [{
          required: true,
          message: '请输入保质期',
          trigger: 'blur'
        }],
        storageConditions: [{
          required: true,
          message: '请输入存储条件',
          trigger: 'blur'
        }],
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    this.$route.query.id && this.detail()
  },
  mounted() {
  },
  methods: {
    submitForm() {
      let _this = this
      this.$refs['form'].validate(valid => {
        if (!valid) return
        _this.fullscreenLoading = true
        _this.$common.my_ajax({
          url: 'traceability/saveTraceability',
          data: _this.form,
          success: function (response) {
            _this.fullscreenLoading = false
            _this.$notify.success("修改成功")
          }
        });
      })
    },
    resetForm() {
      this.$refs['form'].resetFields()
    },
    detail() {
      let _this = this
      _this.$common.my_ajax({
        url: 'traceability/detailTraceability',
        data: {
          traceabilityId: _this.$route.query.id,
        },
        success: function (response) {
          _this.form = response.item
        }
      });
    }
  }
}

</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}

</style>
